import { selectMatchEvents } from 'features/match/matchSlice';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { EventTextProps } from './EventText';
import { getConnectedPlayerOnEvent } from '../../helpers/getConnectedEvent';

const EventTextSubstitution: React.FC<EventTextProps> = ({ matchEvent }) => {
  const matchEvents = useSelector(selectMatchEvents);

  const team = matchEvent?.team?.name;
  const playerOut = matchEvent?.person?.name;

  const connectedEvent = getConnectedPlayerOnEvent(matchEvents, matchEvent);

  const playerIn = connectedEvent?.person?.name;

  const hasJustTeam = team && !playerIn && !playerOut;
  const hasTeamAndPlayerIn = team && playerIn && !playerOut;
  const hasTeamAndPlayerOut = team && playerOut && !playerIn;

  if (hasJustTeam) {
    return <FormattedMessage id="eventText.substitution.justTeam" values={{ team }} />;
  } else if (hasTeamAndPlayerIn) {
    return <FormattedMessage id="eventText.substitution.teamAndPlayerIn" values={{ team, playerIn: playerIn }} />;
  } else if (hasTeamAndPlayerOut) {
    return <FormattedMessage id="eventText.substitution.teamAndPlayerOut" values={{ team, playerOut: playerOut }} />;
  }

  return (
    <FormattedMessage
      id="eventText.playerSubstituted"
      values={{
        team,
        playerIn: playerIn,
        playerOut,
      }}
    />
  );
};

export default EventTextSubstitution;
